import type { PeriodType, SpendingConfiguration } from "../types";

export function periodSummaryText(configuration: SpendingConfiguration, formatter: Intl.NumberFormat) {
  const start = new Date(configuration.startDateIso);
  const end = new Date(start);
  end.setDate(start.getDate() + configuration.totalPeriodDays - 1);

  return `${configuration.periodType === "weekly" ? "Weekly" : "Monthly"} period • ${start.toLocaleDateString()} to ${end.toLocaleDateString()} • ${formatter.format(configuration.periodAllowance)} allowance`;
}

export function dayNumberForDate(date: Date, configuration: SpendingConfiguration) {
  const start = startOfDay(new Date(configuration.startDateIso));
  const selected = startOfDay(date);

  if (selected < start) {
    return 1;
  }

  const calculatedDay = Math.floor((selected.getTime() - start.getTime()) / 86_400_000) + 1;

  return Math.min(calculatedDay, configuration.totalPeriodDays);
}

export function isAfterPeriodEnd(date: Date, configuration: SpendingConfiguration) {
  const start = startOfDay(new Date(configuration.startDateIso));
  const dayAfterEnd = new Date(start);
  dayAfterEnd.setDate(start.getDate() + configuration.totalPeriodDays);

  return startOfDay(date) >= dayAfterEnd;
}

export function totalDaysForPeriod(periodType: PeriodType, startDate: Date) {
  if (periodType === "weekly") {
    return 7;
  }

  return new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0).getDate();
}

function startOfDay(date: Date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}
